import makeStyles from '@mui/styles/makeStyles';
import { SIDEBAR_STEP_MAX_WIDTH } from './helpers/constants';
import {
  checkboxLabel,
  hintStrip,
  labeledInputSpacing
} from './parts/shared/ui/styles';

export const createClasses = makeStyles(theme => ({
  container: {
    maxWidth: SIDEBAR_STEP_MAX_WIDTH,
    ...labeledInputSpacing
  },

  heading: {
    // Leave room for the drawer's X button; matches the Figma two-line wrap.
    maxWidth: '480px',
    marginBottom: theme.spacing(0.5),

    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  subtitle: {
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(4)
  },

  inputLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },

  icon: {
    fontSize: theme.typography.body1.fontSize
  },

  warning: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error[200],
    borderRadius: '4px',

    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  warningIcon: {
    marginBottom: theme.spacing(1.75)
  },

  checkbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    height: '17px',

    '& span': {
      paddingLeft: 0
    }
  },
  loader: {
    marginTop: theme.spacing(3)
  },
  regionAttention: {
    marginBottom: theme.spacing(3)
  },
  // Figma 73:1782: box copy is caption (12/15) in Primary/400; the numbered
  // list sits flush with the box padding, items 8px apart.
  approachText: {
    fontSize: '12px',
    lineHeight: '15px',
    color: theme.palette.text.secondary
  },
  approachTitle: {
    // Figma separates the body from "The recommended approach:" with a blank
    // 15px caption line; the box gap contributes 12px of it.
    marginTop: '3px'
  },
  approachList: {
    margin: 0,
    padding: 0,
    listStylePosition: 'inside',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    '& > li': {
      fontSize: '12px',
      lineHeight: '15px'
    }
  },
  inputHint: {
    ...hintStrip(theme),
    marginTop: theme.spacing(1)
  },
  confirmCheckbox: {
    ...checkboxLabel(theme),
    marginTop: theme.spacing(3),
    // The SMB frame (555:2186) uses the 14/19 body style for this label,
    // unlike the wizard screens' 14/17.
    '& p': {
      fontSize: '14px',
      lineHeight: '19px',
      color: theme.palette.primary[500]
    }
  }
}));
